export default __webpack_public_path__ + "static/media/space2.8d186837.png";